import { createSlice } from '@reduxjs/toolkit';
import { UsersStore } from './store';
export const usersSlice = createSlice({
    name: '@@USERS',
    initialState: UsersStore.empty(),
    reducers: (create)=>({
            putAll: create.reducer((state, { payload: users })=>UsersStore.putAll(users)()),
            added: create.reducer((state, { payload: user })=>UsersStore.added(user)(state)),
            addedAll: create.reducer((state, { payload: users })=>UsersStore.addedAll(users)(state))
        })
});
